import { Component, EventEmitter, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../services/api/api/api.service';

@Component({
  selector: 'app-s3-file-upload',
  templateUrl: './s3-file-upload.component.html',
  styleUrls: ['./s3-file-upload.component.scss'],
})
export class S3FileUploadComponent {
  file: any;

  fileObj: File;
  errorMsg: boolean;
  uploading = false;
  uploadS3URL = '';
  unsubscribe$ = new Subject<void>();

  @Output()
  fileUploadedEvent = new EventEmitter();

  constructor(private _api: ApiService) {}

  onFilePicked(event: Event): void {
    console.log('event: ', event);

    this.errorMsg = false;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const FILE = (event.target as HTMLInputElement).files[0];
    this.fileObj = FILE;
  }

  onFileUpload(): void {
    this.uploading = true;

    if (!this.fileObj) {
      this.errorMsg = true;
      return;
    }

    console.log('fileObj: ', this.fileObj);

    const data = {
      key: this.fileObj.name,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      ContentType: this.fileObj.type,
    };
    this._api
      .generatedSignedURL(data)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        console.log('res: ', res);

        const fileuploadurl = res.presignedURL;
        console.log('fileuploadurl: ', fileuploadurl);

        const fileForm = new FormData();
        fileForm.append('file', this.fileObj);
        this._api
          .uploadfileAWSS3(fileuploadurl, this.fileObj.type, this.fileObj, true)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((event) => {
            console.log('res emitted: ', res);
            this.uploading = false;
            console.log('event emitted: ', event);
            this.fileUploadedEvent.emit(res['url']);
          });
      });
  }
}
